import copy from 'clipboard-copy';
import { useTranslation } from 'react-i18next';

import { useReferralLink } from 'src/hooks/useReferralLink';
import { useAppDispatch } from 'src/hooks/useStore';
import { alertSnackbar } from 'src/store/ui/actions';

/** The workspace's referral link and a copy action that confirms in a toast. */
export function useCopyReferralLink() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { referralLink } = useReferralLink();

  const copyReferralLink = async () => {
    await copy(referralLink);
    dispatch(
      alertSnackbar({
        successMessage: t(($) => $.page_settings_referrals.link.copied),
      }),
    );
  };

  return { referralLink, copyReferralLink };
}
